import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const payForAnyUnpaidGroceries = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation PayForAnyUnpaidGroceries($phoneNumber: String!) {
        payForAnyUnpaidGroceries(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.payForAnyUnpaidGroceries ?? '';
};
